import { Alert, AlertTitle } from '@material-ui/lab';
import { useUserStore } from '@roc/feature-app-core';
import qr_code_ios_faco from '../assets/qr_code_ios_faco.png';
import qr_code_ios_civic from '../assets/qr_code_ios_civic.png';
import qr_code_ios_roc from '../assets/qr_code_ios_roc.png';
import qr_code_ios_plp from '../assets/qr_code_ios_plp.png';
import qr_code_android_faco from '../assets/qr_code_android_faco.png';
import qr_code_android_civic from '../assets/qr_code_android_civic.png';
import qr_code_android_roc from '../assets/qr_code_android_roc.png';
import qr_code_android_plp from '../assets/qr_code_android_plp.png';
import { AlertDialog } from '@roc/ui';
import { useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import { observer } from 'mobx-react';
import { MorganStanleyAlert } from './morganStanleyAlert';
import { useDrawsStore } from '../hooks';

export const MobileSnapDrawAlert = observer(({ isMobileDraw, investor, lenderId }) => {
  const { userStore } = useUserStore();
  const [showDownload, setShowDownload] = useState(false);

  const MORGAN_STANLEY = "Morgan Stanley";
  return isMobileDraw ? (
    <>
      {(!userStore.isNportalUser) && (
        <Alert
          severity="info"
          action={
            <Button
              style={{ color: 'inherit' }}
              variant="outlined"
              onClick={() => setShowDownload(true)}
            >
              Download
            </Button>
          }
        >
          <AlertTitle>
            <strong>Mobile Snap Draw</strong>
          </AlertTitle>
          Heads up! We have a new mobile app for completing tasks such as
          inspection photos. Please use the app. <br />
          Download it{' '}
          <span
            style={{ textDecoration: 'underline', cursor: 'pointer' }}
            onClick={() => setShowDownload(true)}
          >
            here
          </span>
          .
        </Alert>
      )}
      {userStore.isNportalUser && (
        <Alert severity="info">
          <AlertTitle>
            <strong>Mobile Snap Draw</strong>
          </AlertTitle>
          This draw type is new "Mobile Snap Draw"

          {MORGAN_STANLEY === investor && (
            <>
              <AlertTitle style={{ paddingTop: '12px' }}>
                <strong>Snap Draw</strong>
              </AlertTitle>
              No snap draws available for draws greater than $100,000
            </>
          )}
        </Alert>
      )}
      <DownloadMobileAppDialog
        open={showDownload}
        onClose={() => setShowDownload(false)}
        lenderId={lenderId}
      />
    </>
  ) : (userStore.isNportalUser && MORGAN_STANLEY === investor) ? (
    <MorganStanleyAlert />
  ) : null;
});

export const DownloadMobileAppDialog = observer(({ open, onClose, lenderId }) => {
  const { pointOfContactStore } = useDrawsStore();

  useEffect(() => {
    if (lenderId) {
      pointOfContactStore.fetchLenderInfo(lenderId);
    }
  }, [lenderId]);

  const lenderPortalId = pointOfContactStore.lenderInfo?.portalId;

  useEffect(() => {
    if (lenderPortalId) {
      pointOfContactStore.fetchLenderPortalHost(lenderPortalId);
    }
  }, [lenderPortalId]);

  const portalHost = pointOfContactStore.lenderPortalHost ?? '';
  const isFaco = /facolending/.test(portalHost);
  const isCivic = /civicfs/.test(portalHost);
  const isRocCapital = /roccapital/.test(portalHost);
  const isPLP = /privatelenderportal/.test(portalHost) || (!isFaco && !isCivic && !isRocCapital);

  const IOS_FACO = (
    <a href="https://apps.apple.com/us/app/faco-lending/id6749899396?platform=iphone">
      <img src={qr_code_ios_faco} width="220" height="220" />
    </a>
  );

  const ANDROID_FACO = (
    <a href="https://play.google.com/store/apps/details?id=com.plp.faco">
      <img src={qr_code_android_faco} width="220" height="220" />
    </a>
  );

  const IOS_CIVIC = (
    <a href="https://apps.apple.com/us/app/civic-fs/id6749899152?platform=iphone">
      <img src={qr_code_ios_civic} width="220" height="220" />
    </a>
  );

  const ANDROID_CIVIC = (
    <a href="https://play.google.com/store/apps/details?id=com.plp.civic">
      <img src={qr_code_android_civic} width="220" height="220" />
    </a>
  );

  const IOS_ROC = (
    <a href="https://apps.apple.com/us/app/roc-capital/id6752585575?platform=iphone">
      <img src={qr_code_ios_roc} width="220" height="220" />
    </a>
  );

  const ANDROID_ROC = (
    <a href="https://play.google.com/store/apps/details?id=com.plp.roc">
      <img src={qr_code_android_roc} width="220" height="220" />
    </a>
  );

  const IOS_PLP = (
    <a href="https://apps.apple.com/us/app/private-lender-portal/id6751991859?platform=iphone">
      <img src={qr_code_ios_plp} width="220" height="220" />
    </a>
  );

  const ANDROID_PLP = (
    <a href="https://play.google.com/store/apps/details?id=com.plp.privatelenderportal">
      <img src={qr_code_android_plp} width="220" height="220" />
    </a>
  );

  return (
    <AlertDialog
      title="Download Mobile App"
      open={open}
      maxWidth="sm"
      handleClose={onClose}
      body={
        <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          {isPLP && (
            <>
              {IOS_PLP} {ANDROID_PLP}
            </>
          )}
          {isFaco && (
            <>
              {IOS_FACO} {ANDROID_FACO}
            </>
          )}
          {isCivic && (
            <>
              {IOS_CIVIC} {ANDROID_CIVIC}
            </>
          )}
          {isRocCapital && (
            <>
              {IOS_ROC} {ANDROID_ROC}
            </>
          )}
        </div>
      }
    />
  );
});
